import Card from "./Card";

interface JournalThemesCardProps {
  themes: string[];
}

export default function JournalThemesCard({ themes }: JournalThemesCardProps) {
  if (themes.length === 0) {
    return (
      <Card title="Journal Themes">
        <p className="text-sm text-stone-400 italic">No journal entries recorded yet.</p>
      </Card>
    );
  }

  return (
    <Card title="Journal Themes">
      <div className="flex flex-wrap gap-2 mb-3">
        {themes.map((t, i) => (
          <span
            key={t}
            className="px-3.5 py-1.5 rounded-full text-xs font-medium"
            style={
              i < 3
                ? { background: "#C6D8A5", color: "#fff" }
                : { background: "#f5f3ef", color: "#2C2C2C", border: "1px solid #E8E2DA" }
            }
          >
            {t}
          </span>
        ))}
      </div>
      <p className="text-xs text-stone-400">
        Top {Math.min(3, themes.length)} themes highlighted — extracted from your journal entries.
      </p>
    </Card>
  );
}
